<template>
  <main>
    <div class="tab-header">
      <div class="container-fluid">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item" :class="{'active': currentTab === 0}"
            v-if="
              UserInfo.roles.hasOwnProperty('RLZZ0MX') ||
              UserInfo.roles.hasOwnProperty('RLZZ0MV') ||
              UserInfo.roles.hasOwnProperty('RLMX001') ||
              UserInfo.roles.hasOwnProperty('RLMX004')
            "
          >
            <a href="javascript:void(0);" class="nav-link" :class="{ active: currentTab === 0, show: currentTab === 0 }" @click="currentTab = 0" role="tab">以業務員及客戶查詢</a>
          </li>
          <li class="nav-item" :class="{'active': currentTab === 1}"
            v-if="
              UserInfo.roles.hasOwnProperty('RLZZ0MX') ||
              UserInfo.roles.hasOwnProperty('RLZZ0MV') ||
              UserInfo.roles.hasOwnProperty('RLMX001') ||
              UserInfo.roles.hasOwnProperty('RLMX004')
            "
          >
            <a href="javascript:void(0);" class="nav-link" :class="{ active: currentTab === 1, show: currentTab === 1 }" @click="currentTab = 1" role="tab">以保單號碼查詢</a>
          </li>
          <li class="nav-item" :class="{'active': currentTab === 2}"
            v-if="
              UserInfo.roles.hasOwnProperty('RLZZ0MX') ||
              UserInfo.roles.hasOwnProperty('RLZZ0MV') ||
              UserInfo.roles.hasOwnProperty('RLMX001') ||
              UserInfo.roles.hasOwnProperty('RLMX004')
            "
          >
            <a href="javascript:void(0);" class="nav-link" :class="{ active: currentTab === 2, show: currentTab === 2 }" @click="currentTab = 2" role="tab">服務件調撥查詢</a>
          </li>
          <li class="nav-item" :class="{'active': currentTab === 3}"
            v-if="
              UserInfo.roles.hasOwnProperty('RLZZ0MX') ||
              UserInfo.roles.hasOwnProperty('RLZZ0MV') ||
              UserInfo.roles.hasOwnProperty('RLMX001') ||
              UserInfo.roles.hasOwnProperty('RLMX004') ||
              UserInfo.roles.hasOwnProperty('RLMX006')
            "
          >
            <a href="javascript:void(0);" class="nav-link" :class="{ active: currentTab === 3, show: currentTab === 3 }" @click="currentTab = 3" role="tab">保單健檢相關</a>
          </li>
          <li class="nav-item" :class="{'active': currentTab === 4}"
            v-if="
              UserInfo.roles.hasOwnProperty('RLZZ0MX') ||
              UserInfo.roles.hasOwnProperty('RLZZ0MV') ||
              UserInfo.roles.hasOwnProperty('RLMX001') ||
              UserInfo.roles.hasOwnProperty('RLMX004')
            "
          >
            <a href="javascript:void(0);" class="nav-link" :class="{ active: currentTab === 4, show: currentTab === 4 }" @click="currentTab = 4" role="tab">BOX紀錄查詢</a>
          </li>
          <li class="nav-item" :class="{'active': currentTab === 5}"
            v-if="
              UserInfo.roles.hasOwnProperty('RLZZ0MX') ||
              UserInfo.roles.hasOwnProperty('RLZZ0MV') ||
              UserInfo.roles.hasOwnProperty('RLMX001') ||
              UserInfo.roles.hasOwnProperty('RLMX008')
            "
          >
            <a href="javascript:void(0);" class="nav-link" :class="{ active: currentTab === 5, show: currentTab === 5 }" @click="currentTab = 5" role="tab">增值回饋分享金試算表</a>
          </li>
          <li class="nav-item" :class="{'active': currentTab === 6}"
            v-if="
              UserInfo.roles.hasOwnProperty('RLZZ0MX') ||
              UserInfo.roles.hasOwnProperty('RLZZ0MV') ||
              UserInfo.roles.hasOwnProperty('RLMX001') ||
              UserInfo.roles.hasOwnProperty('RLMX004') ||
              UserInfo.roles.hasOwnProperty('RLMX006') ||
              UserInfo.roles.hasOwnProperty('RLMX008') ||
              (isTestEnv && UserInfo.divNo === '9400400' && UserInfo.roles.hasOwnProperty('RLZZ987'))
            "
          >
            <a href="javascript:void(0);" class="nav-link" :class="{ active: currentTab === 6, show: currentTab === 6 }" @click="currentTab = 6" role="tab">同業保單資料查詢</a>
          </li>         
        </ul>
      </div>
    </div>
    <div class="tab-content">
      <div class="container-fluid">
        <div id="tab-0" class="tab-pane" :class="{ active: currentTab === 0, show: currentTab === 0 }" role="tabpanel">
          <section>
            <h3 class="text-green my-4 mx-2">查詢業務員與客戶關係</h3>
            <!--共同行銷查詢-->
            <form class="form">
              <div class="form-group row">
                <div class="col-11">
                  <label for="cust-id" class="col-4 text-right">客戶ID</label>
                  <input
                    type="text"
                    id="cust-id"
                    :class="{ 'is-invalid': is_custId_cm_error }"
                    class="form-control form-control-inline"
                    placeholder="客戶ID"
                    v-model="custId_cm"
                  />
                  <a href="#" @click.prevent="cm_doSearchFor" class="btn btn-primary mt-0">查詢</a>
                </div>
              </div>
            </form>
          </section>
          <section>
            <table
              class="table datatable table-striped table-bordered col-8"
            >
              <thead>
                <tr>
                  <th :width="`${0.11 * tableWidth}px`">死亡來源</th>
                  <th :width="`${0.11 * tableWidth}px`">是否同意產險共銷</th>
                  <th :width="`${0.13 * tableWidth}px`">是否不作保健(輸入日期)</th>
                  <th :width="`${0.13 * tableWidth}px`">客戶的密戶件</th>
                  <th>客戶申請拒絕國泰人壽行銷(拒絕蒐集處理個資)</th>
                </tr>
              </thead>
              <tbody v-if="cm_tableData">
                <tr>
                  <td :width="`${0.11 * tableWidth}px`" v-html="cm_tableData.die_source"></td>
                  <td :width="`${0.11 * tableWidth}px`">{{cm_tableData.csagree}}</td>
                  <td :width="`${0.13 * tableWidth}px`">{{cm_tableData.ishealth}}</td>
                  <td :width="`${0.13 * tableWidth}px`">{{cm_tableData.issec}}</td>
                  <td>{{cm_tableData.isrefusemkt}}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td v-if="!cm_loading" colspan="5" class="empty-block-sm">
                    <h5>{{this.sm_showMsg}}</h5>
                  </td>
                  <td v-else colspan="5" class="empty-block-sm">
                    <h5>
                      <div class="section-loading d-inline-block" style="height:20px; width:30px"></div>資料載入中
                      <span>. . .</span>
                    </h5>
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
          <br/>
          <br/>
          <!--一般查詢-->
          <section>
            <form class="form">
              <div class="form-group row">
                <div class="col-11">
                  <label for="ag-id" class="col-4 text-right">業務員ID</label>
                  <input
                    type="text"
                    id="ag-id"
                    class="form-control form-control-inline"
                    placeholder="業務員ID"
                    v-model="agId"
                  />
                  <label for="cust-id" class="col-4 text-right">客戶ID</label>
                  <input
                    type="text"
                    id="cust-id"
                    :class="{ 'is-invalid': is_custId_error }"
                    class="form-control form-control-inline"
                    placeholder="客戶ID"
                    v-model="custId"
                  />
                  <a href="#" @click.prevent="doSearch" class="btn btn-primary mt-0">查詢</a>
                </div>
              </div>
            </form>
          </section>
          <section>
            <table
              id="query-datatable"
              class="filter-result-table table datatable table-striped table-bordered"
            >
              <thead>
                <tr>
                  <th :width="`${0.16 * tableWidth}px`">業務員ID</th>
                  <th :width="`${0.09 * tableWidth}px`">業務員姓名</th>
                  <th :width="`${0.09 * tableWidth}px`">客戶姓名</th>
                  <th :width="`${0.155 * tableWidth}px`">客戶修檔來源</th>
                  <th :width="`${0.165 * tableWidth}px`">客戶檔修改時間</th>
                  <th :width="`${0.225 * tableWidth}px`">是否設定不給業務員看(輸入日期)</th>
                </tr>
              </thead>
              <tbody v-if="tableData.length > 0" :style="`height: ${data_table_height}px;`">
                <tr v-for="(d, did) in tableData" :key="`td-${did}`">
                  <td :width="`${0.16 * tableWidth}px`">{{d.agnt_id}}</td>
                  <td :width="`${0.09 * tableWidth}px`">{{d.ag_name}}</td>
                  <td :width="`${0.09 * tableWidth}px`">{{d.name}}</td>
                  <td :width="`${0.155 * tableWidth}px`">{{d.upd_source}}</td>
                  <td :width="`${0.165 * tableWidth}px`">{{d.upd_time | ymdsDateFormat}}</td>
                  <td :width="`${0.225 * tableWidth}px`">{{d.in_type}}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td v-if="!loading" colspan="8" class="empty-block">
                    <h3>{{this.showMsg}}</h3>
                  </td>
                  <td v-else colspan="8" class="empty-block">
                    <h3>
                      <div class="section-loading d-inline-block" style="height:20px; width:30px"></div>資料載入中
                      <span>. . .</span>
                    </h3>
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>
        <div id="tab-1" class="tab-pane" :class="{ active: currentTab === 1, show: currentTab === 1 }" role="tabpanel">
          <section>
            <h3 class="text-green my-4 mx-2">以保單號碼查詢</h3>
            <form class="form">
              <div class="form-group row">
                <div class="col-11">
                  <label for="policy-no" class="col-4 text-right">保單號碼</label>
                  <input
                    type="text"
                    id="policy-no"
                    class="form-control form-control-inline"
                    placeholder="保單號碼"
                    v-model="policyNo"
                  />
                  <a href="#" @click.prevent="p_doSearch" class="btn btn-primary mt-0">查詢</a>
                </div>
              </div>
            </form>
            <div class="ml-2 mb-2"><label>* 僅供查詢CRM有效保單定義下之保單，若為無效、失效保單請至壽險核心系統查詢。</label></div>
          </section>
          <section>
            <table
              id="p_query-datatable"
              class="filter-result-table table datatable table-striped table-bordered"
            >
              <thead>
                <tr>
                  <th :width="`${0.13 * tableWidth}px`">經手人</th>
                  <th :width="`${0.13 * tableWidth}px`">收費人員(收費代號)</th>
                  <th :width="`${0.1 * tableWidth}px`">有自行輸入國壽保單的業務員ID</th>
                  <th :width="`${0.1 * tableWidth}px`">險種名稱(代號)</th>
                  <th :width="`${0.1 * tableWidth}px`">契約效力(代號)</th>
                  <th :width="`${0.1 * tableWidth}px`">要保人(ID)</th>
                  <th :width="`${0.1 * tableWidth}px`">被保人(ID)</th>
                  <th :width="`${0.09 * tableWidth}px`">密戶件類型</th>
                  <th>被保人-死亡來源(輸入日期)</th>
                </tr>
              </thead>
              <tbody v-if="p_tableData.length > 0" :style="`height: ${data_table_height}px;`">
                <tr v-for="(d, did) in p_tableData" :key="`td-${did}`">
                  <td :width="`${0.13 * tableWidth}px`">{{d.dealer}}</td>
                  <td :width="`${0.13 * tableWidth}px`">{{d.toller}}</td>
                  <td :width="`${0.1 * tableWidth}px`">{{d.cathay_agnt_id}}</td>
                  <td :width="`${0.1 * tableWidth}px`">{{d.prod_name}}</td>
                  <td :width="`${0.1 * tableWidth}px`">{{d.prod_effect}}</td>
                  <td :width="`${0.1 * tableWidth}px`">{{d.apc_name}}</td>
                  <td :width="`${0.1 * tableWidth}px`">{{d.insd_name}}</td>
                  <td :width="`${0.09 * tableWidth}px`">{{d.issec}}</td>
                  <td v-html="d.die_source"></td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td v-if="!p_loading" colspan="9" class="empty-block">
                    <h3>{{this.showMsg}}</h3>
                  </td>
                  <td v-else colspan="9" class="empty-block">
                    <h3>
                      <div class="section-loading d-inline-block" style="height:20px; width:30px"></div>資料載入中
                      <span>. . .</span>
                    </h3>
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>
        <div id="tab-2" class="tab-pane" :class="{ active: currentTab === 2, show: currentTab === 2 }" role="tabpanel">
          <section>
            <h3 class="text-green my-4 mx-2">調撥原因查詢</h3>
            <table>
              <tr>
                <th>撥出收費代號</th>
                <td>
                  <input
                    type="text"
                    id="out-ceclcno"
                    class="form-control form-control-inline"
                    placeholder="撥出收費代號"
                    v-model="outCeclcno"
                    @input="check()"
                  />
                </td>
                <td style="width:30px"></td>
                <th>調撥日期</th>
                <td class="d-flex flex-column">
                  <div class="d-flex align-items-center">
                    <div class="d-flex align-items-center">
                      <date-picker
                        ref="picker"
                        v-model="beginDate"
                        :format="dateFormatter"
                        :language="dateLang"
                        :first-day-of-week="1"
                      />
                      <div
                        class="d-flex justify-content-end"
                        style="position: absolute; width:138px; height: 40px; font-size: 22px; color: #f58818; pointer-events: none;"
                      >
                        <img
                          style="position: relative; width: 18px; pointer-events: auto;"
                          src="../../../public/assets/common/icon-close-red.svg"
                          v-show="beginDate"
                          @click="$refs.picker.clearDate()"
                        />
                      </div>
                      <div
                        class="d-flex justify-content-end align-items-center"
                        style="padding:0 10px 0 50px; height: 40px; font-size: 24px; color: #f58818; outline: none;"
                        tabindex="-1"
                        @click="$refs.picker.showCalendar()"
                        @blur="$refs.picker.close()"
                      >
                        <i class="icon-calendar" />
                        <span style="color:black">~</span>
                      </div>
                    </div>
                    <span>&nbsp;&nbsp;</span>
                    <div class="d-flex align-items-center">
                      <date-picker
                        ref="picker2"
                        v-model="endDate"
                        :format="dateFormatter"
                        :language="dateLang"
                        :first-day-of-week="1"
                      />
                      <div
                        class="d-flex justify-content-end"
                        style="position: absolute; width:138px; height: 40px; font-size: 22px; color: #f58818; pointer-events: none;"
                      >
                        <img
                          style="position: relative; width: 18px; pointer-events: auto;"
                          src="../../../public/assets/common/icon-close-red.svg"
                          v-show="endDate"
                          @click="$refs.picker2.clearDate()"
                        />
                      </div>
                      <div
                        class="d-flex align-items-center"
                        style="padding:0 10px 0 50px; height: 40px; font-size: 24px; color: #f58818; outline: none;"
                        tabindex="-1"
                        @click="$refs.picker2.showCalendar()"
                        @blur="$refs.picker2.close()"
                      >
                        <i class="icon-calendar" />
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>撥入收費代號</th>
                <td>
                  <input
                    type="text"
                    id="in-ceclcno"
                    class="form-control form-control-inline"
                    placeholder="撥入收費代號"
                    v-model="inCeclcno"
                    @input="check()"
                  />
                </td>
                <td></td>
                <th>保單號碼</th>
                <td>
                  <input
                    type="text"
                    id="c-policy-no"
                    class="form-control form-control-inline"
                    placeholder="保單號碼"
                    v-model="c_policyNo"
                    @input="check()"
                  />
                  <span>
                    &nbsp;&nbsp;
                    <a
                      href="#"
                      @click.prevent="c_doSearch"
                      class="btn btn-primary mt-0"
                    >查詢</a>
                  </span>
                </td>
              </tr>
            </table>
          </section>
          <section>
            <table
              id="c_query-datatable"
              class="filter-result-table table datatable table-striped table-bordered"
            >
              <thead>
                <tr>
                  <th :width="`${0.15 * tableWidth}px`">保單號碼</th>
                  <th :width="`${0.15 * tableWidth}px`">撥出收費代號</th>
                  <th :width="`${0.2 * tableWidth}px`">撥出原因</th>
                  <th :width="`${0.15 * tableWidth}px`">撥入收費代號</th>
                  <th :width="`${0.15 * tableWidth}px`">調撥日期</th>
                  <th>調撥時間</th>
                </tr>
              </thead>
              <tbody v-if="c_tableData.length > 0" :style="`height: ${data_table_height}px;`">
                <tr v-for="(d, did) in c_tableData" :key="`td-${did}`">
                  <td :width="`${0.15 * tableWidth}px`">{{d.ceplcno}}</td>
                  <td :width="`${0.15 * tableWidth}px`">{{d.ceclcno_old}}</td>
                  <td :width="`${0.2 * tableWidth}px`">{{d.code_nm}}</td>
                  <td :width="`${0.15 * tableWidth}px`">{{d.ceclcno_new}}</td>
                  <td :width="`${0.15 * tableWidth}px`">{{d.date | dateFormat}}</td>
                  <td>{{d.timestp}}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td v-if="!c_loading" colspan="6" class="empty-block">
                    <h3>{{this.showMsg}}</h3>
                  </td>
                  <td v-else colspan="6" class="empty-block">
                    <h3>
                      <div class="section-loading d-inline-block" style="height:20px; width:30px"></div>資料載入中
                      <span>. . .</span>
                    </h3>
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>
        <div id="tab-3" class="tab-pane" :class="{ active: currentTab === 3, show: currentTab === 3 }" role="tabpanel">
          <section>
            <h3 class="text-green my-4 mx-2">新舊系統報表比對</h3>
            <form class="form">
              <div class="form-group row">
                <div class="col-11">
                  <label for="agidno" class="col-4 text-right">業務員ID</label>
                  <input
                    type="text"
                    id="agidno"
                    class="form-control form-control-inline"
                    placeholder="業務員ID"
                    v-model="agidno"
                  />
                  <label for="csidno" class="col-4 text-right">客戶ID</label>
                  <input
                    type="text"
                    id="csidno"
                    class="form-control form-control-inline"
                    placeholder="客戶ID"
                    v-model="csidno"
                  />
                  <a href="#" @click.prevent="doCompare" class="btn btn-primary mt-0">新舊報表比對</a>
                </div>
              </div>
            </form>
          </section>
          <section>
            <table
              id="d_query-datatable"
              class="filter-result-table table datatable table-striped table-bordered"
            >
              <thead>
                <tr>
                  <th :width="`${0.2 * tableWidth}px`">報表名稱</th>
                  <th :width="`${0.3 * tableWidth}px`">新MV不同內容</th>
                  <th :width="`${0.3 * tableWidth}px`">舊.Net不同內容</th>
                  <th>比對時間</th>
                </tr>
              </thead>
              <tbody v-if="comparedData.length > 0" style="height:auto;">
                <tr v-for="(data, index) in comparedData" :key="`td-${index}`">
                  <td :width="`${0.2 * tableWidth}px`">{{data.report_name}}</td>
                  <td :width="`${0.3 * tableWidth}px`">{{data.mv_diffmsg}}</td>
                  <td :width="`${0.3 * tableWidth}px`">{{data.dotnet_diffmsg}}</td>
                  <td>{{data.compare_time}}</td>
                </tr>
              </tbody>
              <tbody v-else style="height:auto;">
                <tr>
                  <td v-if="!compare_loading" colspan="6" class="empty-block">
                    <h3>{{this.showMsg}}</h3>
                  </td>
                  <td v-else colspan="6" class="empty-block">
                    <h3>
                      <div class="section-loading d-inline-block" style="height:20px; width:30px"></div>報表比對進行中
                      <span>. . .</span>
                    </h3>
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
          <section>
            <h3 class="text-green my-4 mx-2">個險保障重新計算</h3>
            <form class="form">
              <div class="form-group row">
                <div class="col-11">
                  <label for="plcno" class="col-4 text-right">保單號碼</label>
                  <input
                    type="text"
                    id="plcno"
                    class="form-control form-control-inline"
                    placeholder="保單號碼"
                    v-model="plcno"
                  />
                  <a href="#" @click.prevent="doRecaculate" class="btn btn-primary mt-0">重新計算</a>
                </div>
              </div>
            </form>
          </section>
          <section>
            <h3 class="text-green my-4 mx-2">團險保障重新計算</h3>
            <form class="form">
              <div class="form-group row">
                <div class="col-11">
                  <label for="groupplcno" class="col-4 text-right">保單號碼</label>
                  <input
                    type="text"
                    id="groupplcno"
                    class="form-control form-control-inline"
                    placeholder="保單號碼"
                    v-model="groupplcno"
                  />
                  <label for="groupcsidno" class="col-4 text-right">客戶ID</label>
                  <input
                    type="text"
                    id="groupcsidno"
                    class="form-control form-control-inline"
                    placeholder="客戶ID"
                    v-model="groupcsidno"
                  />
                  <a href="#" @click.prevent="doRecaculateGroup" class="btn btn-primary mt-0">重新計算</a>
                </div>
              </div>
            </form>
          </section>
          <div :style="`height: ${tableHeight}px;`"></div>
        </div>
        <div id="tab-4" class="tab-pane" :class="{ active: currentTab === 4, show: currentTab === 4 }" role="tabpanel">
          <section>
            <h3 class="text-green my-4 mx-2">BOX紀錄查詢</h3>
            <table>
              <tr>
                <th>業務員ID</th>
                <td>
                  <input
                    type="text"
                    id="agId_box"
                    class="form-control form-control-inline"
                    placeholder="業務員ID"
                    v-model="agId_box"
                  />
                </td>
                <th>客戶ID</th>
                <td>
                  <input
                    type="text"
                    id="custId_box"
                    class="form-control form-control-inline"
                    placeholder="客戶ID"
                    v-model="custId_box"
                  />
                </td>
              </tr>
              <tr>
                <th>民國年度</th>
                <td>
                  <input
                    type="text"
                    id="rocyear"
                    class="form-control form-control-inline"
                    placeholder="年度"
                    v-model="rocyear"
                  />
                </td>
                <td style="width:100px"></td>
                <td style="width:120px"></td>
                <td>
                  <span>
                    &nbsp;&nbsp;
                    <a
                      href="#"
                      @click.prevent="doSearch_box"
                      class="btn btn-primary mt-0"
                    >查詢</a>
                  </span>
                </td>
              </tr>
            </table>
          </section>
          <section>
            <table
              id="query-datatable"
              class="filter-result-table table datatable table-striped table-bordered"
            >
              <thead>
                <tr>
                  <th
                    :width="`${0.5 * tableWidth}px`"
                    :class="'sorting ' + (order.fieldName == 'EVENT_DATE' ? order.asc ? 'sorting_asc': 'sorting_desc' : '')"
                    @click="columnSorting('EVENT_DATE')"
                  >拜訪日期</th>
                  <th
                    :class="'sorting ' + (order.fieldName == 'UPDATE_TIME' ? order.asc ? 'sorting_asc': 'sorting_desc' : '')"
                    @click="columnSorting('UPDATE_TIME')"
                  >拜訪紀錄更新時間</th>
                </tr>
              </thead>
              <tbody v-if="recordListBackup.length > 0" :style="`height: ${data_table_height}px;`">
                <tr v-for="(d, did) in recordListBackup" :key="`td-${did}`">
                  <td :width="`${0.5 * tableWidth}px`">{{d.EVENT_DATE}}</td>
                  <td>{{d.UPDATE_TIME}}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td v-if="!box_loading" colspan="8" class="empty-block">
                    <h3>{{this.showMsg}}</h3>
                  </td>
                  <td v-else colspan="8" class="empty-block">
                    <h3>
                      <div class="section-loading d-inline-block" style="height:20px; width:30px"></div>資料載入中
                      <span>. . .</span>
                    </h3>
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>

        <div id="tab-5" class="tab-pane" :class="{ active: currentTab === 5, show: currentTab === 5 }" role="tabpanel">
          <section >
            <h3 class="text-green my-4">查詢輸入</h3>
            <form class="form">
              <div class="form-group row align-items-center">
                    <label for="policy-no" class="text-center custom-th ml-2">保單號碼</label>
                    <input id = "policy-no" type="text" v-model="tab5_policyNo" maxlength="10" class="form-control custom-td" @input="numberPolicyNo" placeholder="請輸入保單號碼" />
                    <a href="#" class="btn btn-primary custom-btn ml-3" @click.prevent="tab5_doSearch">查詢</a>
              </div>
            </form>
          </section>

          <section class="mt-4">
            <h3 class="text-green my-4">商品資訊</h3>
            <div class="table-wrapper" style="position: relative;">
              <div v-if="tab5_search_loading" class="table-overlay">
                <h5>
                    <div class="section-loading d-inline-block" style="height:20px; width:30px"></div>資料載入中
                    <span>. . .</span>
                </h5>
              </div>
              <table class="table table-bordered table-striped">
                <tbody v-if="true">
                  <tr>
                    <th style="width: calc(100% / 6)">商品名稱</th>
                    <td colspan="5">{{ tab5_policyInfo.PROD_NAME || ''}}</td>
                  </tr>
                  <tr>
                    <th style="width: calc(100% / 6)">要保人ID</th>
                    <td style="width: calc(100% / 6)">{{ tab5_policyInfo.APC_ID || ''}}</td>
                    <th style="width: calc(100% / 6)">要保人姓名</th>
                    <td style="width: calc(100% / 6)">{{ tab5_policyInfo.APC_NM || ''}}</td>
                    <th style="width: calc(100% / 6)">契約效力</th>
                    <td style="width: calc(100% / 6)">{{ tab5_policyInfo.EFT_CODE_NM || ''}}</td>
                  </tr>
                  <tr>
                    <th>被保人ID</th>
                    <td>{{ tab5_policyInfo.INSD_ID || ''}}</td>
                    <th>被保人姓名</th>
                    <td>{{ tab5_policyInfo.INSD_NM || ''}}</td>
                    <th>累計增購保額</th>
                    <td>{{  tab5_policyInfo.bal_ppo_amt ?
                            Number(tab5_policyInfo.bal_ppo_amt).toFixed(0) : ''}}</td>
                  </tr>
                  <tr>
                    <th>投保始期</th>
                    <td>{{ tab5_policyInfo.ISSUE_DATE || ''}}</td>
                    <th>投保年齡</th>
                    <td>{{ tab5_policyInfo.AGE || ''}}</td>
                    <th>累計增值回饋分享金</th>
                    <td>{{ tab5_policyInfo.bal_acc_dvd ?
                           Number(tab5_policyInfo.bal_acc_dvd).toFixed(0) : ''}}</td>
                  </tr>
                  <tr>
                    <th>主約保額</th>
                    <td>{{tab5_policyInfo.FACE_AMT}}{{tab5_policyInfo.FACE_AMT_UNIT}}</td>
                    <th>繳費年期</th>
                    <td>{{ tab5_policyInfo.PAY_PRD || ''}}</td>
                    <th>目前回饋金給付方式</th>
                    <td>{{ tab5_policyInfo.DVD_KIND_CH || ''}}</td>
                  </tr>
                  <tr>
                    <th>幣別</th>
                    <td>{{ tab5_policyInfo.CURR || ''}}</td>
                    <th>繳別</th>
                    <td>{{ tab5_policyInfo.PAY_FREQ_NM || ''}}</td>
                    <td colspan="2" class="no-border"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section class="mt-4">
            <h3 class="text-green my-4">利率</h3>
            <div class="table-wrapper" style="position: relative;">
              <div v-if="tab5_search_loading" class="table-overlay">
              </div>
              <div class="form-row align-items-center">
                <label class="custom-th ml-2">預定利率</label> 
                <input type="text" class="form-control custom-td border-1"  v-model="tab5_policyInfo.interest_rate" disabled />
                <label class="custom-th">最新宣告利率</label>
                <input type="text" class="form-control custom-td" v-model="tab5_policyInfo.currentDeclaredRate" disabled/>
              </div>
            </div>
          </section>
          <section class="mt-4">
            <h3 class="text-green my-4">試算</h3>
            <div class="form-row align-items-center">
              <label class="custom-th ml-2">試算回饋金給付方式</label>
              <select v-model="tab5_add_method" class="form-control custom-td">
                <option value="">請選擇</option>
                <option value="1">增額繳清</option>
                <option value="2">儲存生息</option>
                <option value="3">減額繳清</option>
              </select>

              <label class="custom-th" v-show="false">是否試算辦理繳清</label>
              <select v-model="tab5_simulatePaidUp" class="form-control custom-td" v-show="false">
                <option value="">請選擇</option>
                <option value="y">是</option>
                <option value="n">否</option>
              </select>
            </div>
          </section>

          <section class="mt-4">
            <div class="d-flex align-items-center">
              <h3 class="text-green my-4 paup-result-title">查詢結果</h3>
              <div class="ml-4 paup-result-message">{{paupResult}}</div>
            </div>
            <a class="btn btn-primary custom-btn mr-4" 
              :class="{ disabled: !isGroup1Enabled, 'section-loading': btn_send_loading }" 
              @click.prevent="isGroup1Enabled && panelOpen('sendEmailModalOpen')">寄送</a>
            <a class="btn btn-primary custom-btn mr-4" 
              :class="{ disabled: !isGroup1Enabled, 'section-loading': btn_open_loading }" 
              @click.prevent="isGroup1Enabled && openPDF()">開啟</a>
            <a class="btn btn-primary custom-btn mr-4" 
              :class="{ disabled: !isGroup1Enabled, 'section-loading': btn_download_loading }" 
              @click.prevent="isGroup1Enabled && download()">下載</a>
            <a class="btn btn-primary custom-btn" 
              :class="{ disabled: !isGroup3Enabled, 'section-loading': btn_paup_loading }" 
              @click.prevent="isGroup3Enabled && queryPaupInfo()">查詢</a>
            <!-- <a class="btn btn-primary custom-btn mr-4" :class="{ disabled: !isActionEnabled, 'section-loading': btn_send_loading }" @click.prevent="panelOpen('sendEmailModalOpen')">寄送</a>
            <a class="btn btn-primary custom-btn mr-4" :class="{ disabled: !isActionEnabled , 'section-loading': btn_open_loading }" @click.prevent="openPDF()" >開啟</a>
            <a class="btn btn-primary custom-btn mr-4" :class="{ disabled: !isActionEnabled, 'section-loading': btn_download_loading }" @click.prevent="download()">下載</a>
            <a class="btn btn-primary custom-btn" :class="{ disabled: !isActionEnabled, 'section-loading': btn_open_loading }" @click.prevent="queryPaupInfo()">查詢</a> -->
          </section>

          <section class="mt-4 text-danger text-left">
            <h3 class="text-green my-4">注意事項</h3>
            <p>1. 本功能係假設以未來宣告利率不變為前提，試算未來年度保單現金值、增值回饋分享金等各項數值，實際宣告利率仍應依本公司每月公告數值為準。</p>
            <p>2. 本功能試算數值僅供參考，各保險金實際申請時，可能因保費繳交時間點未如預期、保單借款、宣告利率調整等因素而有所不同，請同仁向客戶詳加說明。</p>
          </section>
        </div>
        <div id="tab-6" class="tab-pane" :class="{ active: currentTab === 6, show: currentTab === 6 }" role="tabpanel">
          <section>
            <h3 class="text-green my-4 mx-2">同業查詢結果</h3>
            <form class="form">
              <div class="form-group row">
                <div class="col-12 d-flex align-items-center flex-wrap ml-2 mb-4">
                  <label class="mr-2 mb-0 font-weight-bold text-secondary" style="font-size: 14px;">業務員ID</label>
                  <input type="text" class="form-control mr-4" v-model="peer_agid" placeholder="選填" style="width: 150px;" maxlength="10" @input="filterPeerAgid" />

                  <label class="mr-2 mb-0 font-weight-bold text-secondary" style="font-size: 14px;"><span class="text-danger">*</span>建立日期</label>
                  <div class="d-flex align-items-center mr-4" style="height: 38px;">
                    <date-picker ref="peerPickerStart" v-model="peer_startDate" :format="dateFormatter" :language="dateLang" :first-day-of-week="1" />
                    <span class="mx-2">~</span>
                    <date-picker ref="peerPickerEnd" v-model="peer_endDate" :format="dateFormatter" :language="dateLang" :first-day-of-week="1" />
                  </div>

                  <label class="mr-2 mb-0 font-weight-bold text-secondary" style="font-size: 14px;"><span class="text-danger">*</span>input type</label>
                  <select v-model="peer_inputType" class="form-control mr-3" style="width: 160px;">
                    <option value="">請選擇</option>
                    <option value="2">拍照上傳</option>
                    <option value="3">(新)手動輸入</option>
                  </select>

                  <a href="#" @click.prevent="doSearchPeer(1)" class="btn btn-primary mt-0">查詢</a>
                </div>
              </div>
            </form>

            <table class="table datatable table-striped table-bordered mt-3">
              <thead>
                <tr>
                  <th style="min-width: 60px; white-space: nowrap;">序號</th>
                  <th>AGID<br/>業務員ID</th><th>createtimestamp<br/>建立時間</th>
                  <th>contract_id<br/>合約識別碼</th><th>contract_type<br/>契約別</th>
                  <th>policy_id<br/>對應保單Id</th><th>issue_date<br/>投保日期</th>
                  <th>famt<br/>投保金額</th><th>prem<br/>保費</th><th>prem_ntd<br/>保費(新台幣)</th>
                  <th>pay_freq<br/>繳別</th><th>prd<br/>商品年期</th><th>famt_ntd<br/>投保金額(新台幣)</th>
                  <th>input_type<br/>輸入來源</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="peer_loading"><td colspan="14" class="empty-block text-center"><h5>資料載入中...</h5></td></tr>
                <tr v-else-if="peer_tableData.length === 0"><td colspan="14" class="empty-block text-center"><h5>查無資料</h5></td></tr>
                <tr v-else v-for="(item, idx) in peer_tableData" :key="idx">
                  <td>{{ (peer_page - 1) * peer_pageSize + idx + 1 }}</td>
                  <td :title="item.agidno" class="cursor-pointer text-primary font-weight-bold">{{ item.agidno_mask }}</td>
                  <td>{{ item.createtimestamp | ymdDateFormat }}</td>
                  <td
                    class="text-primary cursor-pointer"
                    v-if="item.contract_type == 1 && item.input_type == '2'"
                    @click.stop="onPeerRowClick(item)"
                  >
                    {{ item.contract_id }}
                  </td>
                  <td v-else>{{ item.contract_id }}</td>
                  <td>{{ item.contract_type | mapContractType }}</td>
                  <td>{{ item.policyid }}</td>
                  <td>{{ item.issue_date | ymdDateFormat }}</td>
                  <td>{{ item.famt }}</td>
                  <td>{{ item.prem }}</td>
                  <td>{{ item.prem_ntd }}</td>
                  <td>{{ item.pay_freq | mapPayFreq }}</td>
                  <td>{{ item.prd | mapPrd }}</td>
                  <td>{{ item.famt_ntd }}</td>
                  <td>{{ item.input_type | mapInputType }}</td>
                </tr>
              </tbody>
            </table>

            <div class="d-flex justify-content-between align-items-center mt-2" >
              <div>
                每頁顯示: 
                <select v-model="peer_pageSize" @change="doSearchPeer(1)" class="form-control d-inline-block w-auto">
                  <option :value="10">10</option><option :value="20">20</option>
                  <option :value="30">30</option><option :value="40">40</option><option :value="50">50</option>
                </select>
                筆，共 {{ peer_total }} 筆
              </div>
              <ul class="pagination mb-0">
                <li class="page-item" :class="{ disabled: peer_page === 1 }">
                  <a class="page-link" href="#" @click.prevent="peer_changePage(peer_page - 1)">上一頁</a>
                </li>
                
                <li 
                  class="page-item" 
                  v-for="(p, index) in peer_visiblePages" 
                  :key="index" 
                  :class="{ active: peer_page === p, disabled: p === '...' }"
                >
                  <a class="page-link" href="#" @click.prevent="p !== '...' && peer_changePage(p)">{{ p }}</a>
                </li>
                
                <li class="page-item" :class="{ disabled: peer_page === peer_totalPages }">
                  <a class="page-link" href="#" @click.prevent="peer_changePage(peer_page + 1)">下一頁</a>
                </li>
              </ul>
            </div>
          </section>

          <hr class="my-5" />

          <section>
            <h3 class="text-green my-4 mx-2">辨識結果資料</h3>
            <form class="form">
              <div class="form-group row">
                <div class="col-12 d-flex align-items-center ml-2 mb-4">
                  <label class="mr-3 mb-0 font-weight-bold text-secondary" style="font-size: 15px;"><span class="text-danger">*</span>Contract ID</label>
                  <input type="text" class="form-control mr-3" v-model="recog_contractId" placeholder="Contract ID" style="width: 330px;" />
                  <a href="#" @click.prevent="doSearchRecog()" class="btn btn-primary mt-0 px-4">查詢</a>
                </div>
              </div>
            </form>

            <table class="table datatable table-striped table-bordered mt-3">
              <thead>
                <tr>
                  <th width="15%">contract ID 合約識別碼</th>
                  <th width="25%">image_recognition_result 圖片辨識後結果</th>
                  <th width="25%">recognition_result_modified 更改辨識後結果</th>
                  <th width="25%">image 儲存的圖片</th>
                  <th width="10%">createtimestamp 建立時間</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="recog_loading"><td colspan="5" class="empty-block text-center"><h5>資料載入中...</h5></td></tr>
                <tr v-else-if="recog_tableData.length === 0"><td colspan="5" class="empty-block text-center"><h5>查無資料</h5></td></tr>
                <tr v-else v-for="(item, idx) in recog_tableData" :key="idx">
                  <td>{{ item.contract_id }}</td>
                  <td><pre class="json-pre">{{ formatJson(item.image_recognition_result) }}</pre></td>
                  <td><pre class="json-pre">{{ formatJson(item.recognition_result_modified) }}</pre></td>
                  <td>
                    <div v-if="item.blob_urls">
                    <img v-for="(url, i) in item.blob_urls" :key="i" 
                        :src="url" 
                        class="img-thumbnail mr-1 cursor-pointer" 
                        style="width:230px; height:280px; object-fit: cover;"  @click="openImagePreview(url)" />
                    </div>
                  </td>
                  <td>{{ item.createtimestamp | ymdDateFormat }}</td>
                </tr>
              </tbody>
            </table>
          </section>

          <div v-if="previewImageUrl" class="peer-lightbox" @click="closeImagePreview">
            <img :src="previewImageUrl" @click.stop />
            <span class="peer-close-btn" @click="closeImagePreview">&times;</span>
          </div>
        </div>
      </div>

      <warning-modal 
        :open="warningModalOpen" 
        :showCancel="false" 
        :message="warningMessage" 
        :confirmText="'確定'" 
        @submit="panelClose('warningModalOpen')"
      />

      <send-email-modal
        :open="sendEmailModalOpen"
        :isBnk="false"
        :senderName="$store.state.userInfo.name"
        @close="panelClose('sendEmailModalOpen')" 
        @doSendEmail="doSendEmail"
      />

    </div>
  </main>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import { 
  queryBoxRecord,
  queryRelationship,
  queryRelationshipByPolicyNo,
  queryTransferReasonByConditions,
  getPDFcomparedResult,
  deletePDFcomparedResult,
  recalculateCoverage,
  recalculateCoverageGroup,
  valueAdded_queryPolicyInfo,
  sendValueAddedBonusIllustrationEmail,
  downloadValueAddedBonusIllustration,
  queryPeerPolicyDataAPI,
  downloadImageBlobAPI,
  queryPaupInfo
} from "@/service";
import DatePicker from "@/components/DatePicker/components/Datepicker";
import { zh } from "@/components/DatePicker/locale";
import WarningModal from "@/desktop/components/WarningModal";
import SendEmailModal from '@/desktop/components/SendEmailModal'
import { saveAs } from 'file-saver'

export default {
  name: "QueryRelationship",
  mixins: [commonMixin],
  components: {
    DatePicker,
    WarningModal,
    SendEmailModal
  },
  data() {
    return {
      currentTab: 0,
      loading: false,
      data_table_height: 0,
      tableWidth: 0,
      tableData: [],
      agId: "",
      custId: "",
      is_custId_error: false,
      custId_cm: "",
      cm_tableData: null,
      cm_loading: false,
      is_custId_cm_error: false,
      showMsg: "請輸入查詢資料後按下查詢",
      sm_showMsg: "請輸入查詢資料後按下查詢",
      p_loading: false,
      p_tableData: [],
      policyNo: "",
      c_loading: false,
      c_tableData: [],
      c_policyNo: "",
      beginDate: "",
      endDate: new Date(),
      inCeclcno: "",
      outCeclcno: "",
      dateLang: zh,
      dateFormatter: date => {
        const m = date.getMonth() + 1;
        const d = date.getDate();
        return `${date.getFullYear() - 1911}/${(m < 10 ? "0" : "") + m}/${(d <
        10
          ? "0"
          : "") + d}`;
      },
      comparedData: [],
      compare_loading: false,
      tableHeight: 0,
      agidno: "",
      csidno: "",
      plcno: "",
      groupplcno: "",
      groupcsidno: "",
      agId_box: "",
      custId_box: "",
      rocyear: "",
      recordList: [],
      recordListBackup: [],
      box_loading: false,
      order: {
        fieldName: "EVENT_DATE",
        asc: true
      },
      tab5_policyNo: "",
      tab5_search_loading: false,
      tab5_add_method: "", // 試算回饋金給付方式
      tab5_simulatePaidUp: "", // 是否試算辦理繳清
      tab5_policyInfo: {},
      tab5_level: 0,
      tab5_search_success: false,
      warningModalOpen: false,
      sendEmailModalOpen: false,
      warningMessage: '',
      btn_send_loading: false,
      btn_open_loading: false,
      btn_download_loading: false,
      btn_paup_loading: false,
      mailAttachmentName: "國泰人壽增值回饋分享金試算表.pdf",
      paupInfo: {}, 
      paupResult: "",
      // 同業保單查詢 
      peer_agid: "",
      peer_startDate: "",
      peer_endDate: "",
      peer_inputType: "",
      peer_tableData: [],
      peer_loading: false,
      peer_page: 1,
      peer_pageSize: 10,
      peer_total: 0,
      recog_contractId: "",
      recog_tableData: [],
      recog_loading: false,
      blobUrlMap: {}, 
      previewImageUrl: "",
    };
  },
  computed: {
    isTestEnv() {
      return window.location.hostname.includes('tmycrm');
    },    
    // isActionEnabled() {
    //   return this.tab5_search_success && this.tab5_add_method !== "";
    // },
    peer_totalPages() {
      return Math.ceil(this.peer_total / this.peer_pageSize) || 1;
    },
    peer_visiblePages() {
      const current = this.peer_page;
      const total = this.peer_totalPages;

      if (total <= 6) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }

      if (current <= 4) {
        return [1, 2, 3, 4, 5, '...', total];
      }

      if (current >= total - 3) {
        return [1, '...', total - 4, total - 3, total - 2, total - 1, total];
      }

      return [1, '...', current - 1, current, current + 1, '...', total];
    },
    isGroup1Enabled() {
      if (!this.tab5_search_success) return false;
      return ['1', '2'].includes(this.tab5_add_method);
    },
    isGroup3Enabled() {
      if (!this.tab5_search_success) return false;
      return this.tab5_add_method === '3';
    }    
  },
  watch: {
    currentTab(newVal, oldVal) {
      if (oldVal === 6 || newVal === 6) {
        this.resetTab6();
      }
    }
  },
  methods: {
    check() {
      this.outCeclcno = this.outCeclcno.replace(/[\s]/g, "");
      this.inCeclcno = this.inCeclcno.replace(/[\s]/g, "");
      this.c_policyNo = this.c_policyNo.replace(/[\s]/g, "");
    },
    doSearch() {
      // 查詢業務員與客戶關係
      //  驗證送出
      if (!this.checkInput()) {
        return false;
      }

      // 送出查詢API
      this.loading = true;
      this.tableData = [];
      queryRelationship(
        this.$store.state.userInfo.id,
        this.agId.toUpperCase().trim(),
        this.custId.toUpperCase().trim(),
        "2"
      ).then(result => {
        this.loading = false;
        if (result.header && result.header.status == "200") {
          let rtnList = result.body.lists || [];
          if (rtnList.length === 0) {
            this.showMsg = "查無資料";
          } else {
            this.tableData = rtnList.map(item => {
              return {
                name: item.name || "",
                upd_source: item.upd_source || "",
                upd_time: item.upd_time || "",
                in_type: item.in_type || "",
                issec: item.issec || "",
                agnt_id: item.agnt_id || "",
                ag_name: item.ag_name || ""
              };
            });
          }
        } else {
          //  API Error
          this.setToastMsg(result.header.message);
        }
      });
    },
    cm_doSearchFor() {
      //  驗證送出
      if (!this.cm_checkInput()) {
        return false;
      }

      // 送出查詢API
      this.cm_loading = true;
      this.cm_tableData = null;
      queryRelationship(
        this.$store.state.userInfo.id,
        "",
        this.custId_cm.toUpperCase().trim(),
        "1"
      ).then((result) => {
        this.cm_loading = false;
        if (result.header && result.header.status == "200") {
          let rtnList = result.body.lists || [];
          if (rtnList.length === 0) {
            this.sm_showMsg = "查無資料";
          } else {
            let { die_source, csagree, ishealth, issec, isrefusemkt} = rtnList[0];
            if(die_source || csagree || ishealth || issec || isrefusemkt) {
              this.cm_tableData = {
                die_source: die_source || "",
                csagree: csagree || "",
                ishealth: ishealth || "",
                issec: issec || "",
                isrefusemkt: isrefusemkt || "",
              };
            } else {
              this.sm_showMsg = "查無資料";
            }
          }
        } else {
          //  API Error
          this.setToastMsg(result.header.message);
        }
      });
    },
    p_doSearch() {
      //以保單號碼查詢
      if (!this.p_checkInput()) {
        return false;
      }

      // 送出查詢API
      this.p_loading = true;
      this.p_tableData = [];
      queryRelationshipByPolicyNo(
        this.$store.state.userInfo.id,
        this.policyNo.toUpperCase().trim()
      ).then(result => {
        this.p_loading = false;
        if (result.header && result.header.status == "200") {
          let rtnList = result.body.result || [];
          if (rtnList.length === 0) {
            this.showMsg = "查無資料";
          } else {
            this.p_tableData = rtnList.map(item => {
              return {
                dealer: item.dealer || "",
                toller: item.toller || "",
                cathay_agnt_id: item.cathay_agnt_id || "",
                prod_name: item.prod_name || "",
                prod_effect: item.prod_effect || "",
                apc_name: item.apc_name || "",
                insd_name: item.insd_name || "",
                issec: item.issec || "",
                die_source: item.die_source || ""
              };
            });
          }
        } else {
          //  API Error
          this.setToastMsg(result.header.message);
        }
      });
    },
    c_doSearch() {
      //調撥原因查詢
      if (!this.c_checkInput()) {
        return false;
      }
      // 送出查詢API
      this.c_loading = true;
      this.c_tableData = [];

      let condition = {
        out_ceclcno: this.outCeclcno,
        in_ceclcno: this.inCeclcno,
        begin_date: this.fmDate(this.beginDate),
        end_date: this.fmDate(this.endDate),
        policy_no: this.c_policyNo
      };
      queryTransferReasonByConditions(
        this.$store.state.userInfo.id,
        condition
      ).then(result => {
        this.c_loading = false;
        if (result.header && result.header.status == "200") {
          let rtnList = result.body.result || [];
          if (rtnList.length === 0) {
            this.showMsg = "查無資料";
          } else {
            this.c_tableData = rtnList.map(item => {
              return {
                ceplcno: item.ceplcno || "",
                ceclcno_old: item.ceclcno_old || "",
                code_nm: item.code_nm || "",
                ceclcno_new: item.ceclcno_new || "",
                date: item.date || "",
                timestp: item.timestp
                  ? item.timestp.substring(11, 19)
                  : "" || ""
              };
            });
          }
        } else {
          //  API Error
          this.setToastMsg(result.header.message);
        }
      });
    },
    doSearch_box() {
      // 查詢BOX紀錄查詢
      if (!this.box_checkInput()) {
        return false;
      }
      let is_done = "N";
      this.box_loading = true;
      queryBoxRecord(
        this.$store.state.userInfo.id,
        this.agId_box,
        this.custId_box,
        is_done,
        this.rocyear
      ).then(result => {
        // this.box_loading = false;
        if (result.header && result.header.status == "200") {
          this.recordList = this.formatRecordList(result.body.detail);
          this.recordListBackup = this.recordList.map(ele => {
            return ele;
          });
        } else {
          console.error("查詢BOX紀錄連線異常");
        }
      });
    },
    //回傳BOX紀錄查詢
    formatRecordList(list) {
      return list.map(item => {
        return {
          EVENT_DATE: item.EVENT_DATE || "",
          EVENT_SER_NO: item.EVENT_SER_NO || "",
          EVENT_TIME: item.EVENT_TIME || "",
          EVENT_YEAR: item.EVENT_YEAR || "",
          ISDONE: item.ISDONE || "",
          ISMISS: item.ISMISS || "",
          NOTE_STRING: item.NOTE_STRING,
          UPDATE_TIME: this.dateFormat(item.UPDATE_TIME),
          // NOTE_STRING_FORMAT: this.formatNoteContent(item.NOTE_STRING) || "",
          RECORD_STRING: item.RECORD_STRING || "",
          RECORD_SYMBOL: item.RECORD_SYMBOL || "",
          REFERRAL1: item.REFERRAL1 || "",
          REFERRAL2: item.REFERRAL2 || "",
          SUB_CLS_CODE: item.SUB_CLS_CODE || "",
          isNote: item.isNote || "",
          NOTE_DATE: item.NOTE_DATE || "",
          NOTE_TIME: item.NOTE_TIME || ""
        };
      });
    },
    doCompare() {
      //  驗證輸入欄位送出
      //  驗證送出
      let msg;
      const csidno = this.csidno.trim();
      const agidno = this.agidno.trim();
      if (!csidno && !agidno) {
        msg = "業務員ID和客戶ID不可為空";
      } else if (!csidno) {
        msg = "客戶ID不可為空";
      } else if (!agidno) {
        msg = "業務員ID不可為空";
      }
      if (msg) {
        this.setToastMsg(msg);
        return;
      }

      // 送出查詢API
      this.compare_loading = true;
      this.comparedData = [];
      getPDFcomparedResult(this.$store.state.userInfo.id, agidno, csidno).then(
        result => {
          this.compare_loading = false;
          if (result.header && result.header.status == "200") {
            let rtnList = result.body.result || [];
            if (rtnList.length === 0) {
              this.showMsg = "查無資料";
            } else {
              this.comparedData = rtnList.map(item => {
                return {
                  report_name: item.report_name || "",
                  mv_diffmsg: item.mv_diffmsg || "",
                  dotnet_diffmsg: item.dotnet_diffmsg || "",
                  compare_time: item.compare_time || ""
                };
              });
            }
          } else {
            //  API Error
            this.setToastMsg(result.header.message);
          }
          // 資料渲染完做刪除
          this.$nextTick(() =>
            deletePDFcomparedResult(
              this.$store.state.userInfo.id,
              agidno,
              csidno
            )
          );
          this.reCalHeight();
        }
      );
    },
    doRecaculate() {
      let msg;
      const plcno = this.plcno.trim();
      if (!plcno) {
        msg = "保單號碼不可為空";
      }
      if (msg) {
        this.setToastMsg(msg);
        return;
      }
      recalculateCoverage(this.$store.state.userInfo.id, plcno).then(result => {
        if (result.header.status == "200") alert("個險保障重新計算成功");
        else alert("個險保障重新計算失敗");
      })
    },
    doRecaculateGroup() {
      let msg;
      const plcno = this.groupplcno.trim();
      const csidno = this.groupcsidno.trim();
      if (!plcno) {
        msg = "保單號碼不可為空";
      }
      if (!csidno) {
        msg = "客戶ID不可為空";
      }
      if (msg) {
        this.setToastMsg(msg);
        return;
      }
      console.log("recalculateCoverageGroup", plcno, csidno);
      recalculateCoverageGroup(this.$store.state.userInfo.id, plcno, csidno).then(result => {
        if (result.header.status == "200") alert("團險保障重新計算成功");
        else alert("團險保障重新計算失敗");
      })
    },
    reCalHeight() {
      this.$nextTick(
        () =>
          (this.tableHeight =
            parseInt($(window).height()) -
            375 -
            parseInt($("#d_query-datatable tbody").height()))
      );
    },
    box_checkInput() {
      if (!this.agId_box || !this.custId_box || !this.rocyear) {
        this.setToastMsg("三個欄位為必輸欄位");
        return false;
      }
      return true;
    },
    checkInput() {
      //  驗證送出
      this.is_custId_cm_error = false;
      this.is_custId_error = false;
      if (this.custId == "") {
        this.setToastMsg("客戶 ID 不能為空");
        this.is_custId_error = true;
        return false;
      }
      return true;
    },
    cm_checkInput() {
      //  驗證送出
      this.is_custId_cm_error = false;
      this.is_custId_error = false;
      if (this.custId_cm == "") {
        this.setToastMsg("客戶 ID 不能為空");
        this.is_custId_cm_error = true;
        return false;
      }
      return true;
    },
    p_checkInput() {
      //  驗證送出
      if (this.policyNo == "") {
        this.setToastMsg("保單號碼不能為空");
        return false;
      }
      return true;
    },
    c_checkInput() {
      //  驗證送出
      if (
        !this.outCeclcno &&
        !this.inCeclcno &&
        !this.beginDate &&
        !this.endDate &&
        !this.c_policyNo
      ) {
        this.setToastMsg("查詢條件為空，請輸入任一查詢條件");
        return false;
      }
      return true;
    },
    columnSorting(fieldName) {
      console.log(`>>>>> columnSorting:${fieldName} <<<<<`);
      //切換表頭圖案
      if (this.order.fieldName == fieldName) {
        this.order.asc = !this.order.asc;
      } else {
        console.log("change sort field");
        this.order.fieldName = fieldName;
        this.order.asc = true;
        console.log(this.order);
      }

      //data排序
      let sortOrder = -1;
      if (this.order.asc) {
        sortOrder = 1;
      }
      switch (fieldName) {
        default:
          this.recordListBackup = [];
          setTimeout(() => {
            this.recordListBackup = [...this.recordList];
            this.recordListBackup.sort(
              this.dateCompareFun(sortOrder, fieldName)
            );
          }, 20);
      }
    },
    dateCompareFun(sortOrder, property) {
      return function(a, b) {
        let date_a = new Date(
          a[property] ? a[property] : "1880-01-01"
        ).getTime();
        let date_b = new Date(
          b[property] ? b[property] : "1880-01-01"
        ).getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    dateFormat(val) {
      // 轉換為民國
      if (val) {
        let dataAry = val.split("-");
        dataAry[0] = dataAry[0] * 1 - 1911 + "";
        dataAry = dataAry.join("/");
        dataAry = dataAry.split(".");
        return dataAry[0];
      }
      return "";
    },
    fmDate(date) {
      // 轉換 Date 物件為 'YYYY-MM-DD' string
      if (!date) {
        return "";
      }
      let nowDateY = date
        .getYear()
        .toString()
        .replace(/^./, "20");
      let nowDateM =
        (date.getMonth() + 1).toString().length == 1
          ? `0${(date.getMonth() + 1).toString()}`
          : (date.getMonth() + 1).toString();
      let nowDateD =
        date.getDate().toString().length == 1
          ? `0${date.getDate().toString()}`
          : date.getDate().toString();
      return `${nowDateY}-${nowDateM}-${nowDateD}`;
    },
    begDate() {
      /*
      let today = moment().format("YYYY/MM/DD");
      let month = String(parseInt(today.substring(5, 7)) - 2);
      if (month.length == 1) {
        month = "0" + month;
      }
      let begDate =
        today.substring(0, 4) + "/" + month + "/" + today.substring(8, 10);
      begDate = new Date(begDate);
      */
      return new Date(moment().subtract(2, 'months').format('YYYY/MM/DD'));
    },
    numberPolicyNo() {
      this.tab5_policyNo = this.tab5_policyNo.replace(/[^\d]/g, '');
    },
    getLevel(prod_id){
      const level1List = [
        'WEE', 'ABB', 'WEF', 'WUO', 'WSM', 'WD2', 'WUN', 'WUI', 'WKA', 'WSL', 
        'WKC', 'WUK', 'WUH', 'WZC', 'WQ5', 'CCB', 'WUF', 'WED', 'WUQ', 'WSI',
        'WD1', 'WZD', 'WUP', 'WKB', 'WAU', 'WUJ', 'WSK', 'WE1', 'WEG', 'WUM',
        'WSH', 'WSJ', 'WQ8', 'ABA', 'WTV', 'WUR', 'WQ6', 'WUL', 'WQ7', 'C64',
        'WTW', 'CCA', 'WUZ', 'WUS'
      ]

      // const level2List = [
      //   'WSD', 'DJ', 'WUG', 'WU3', 'DB', 'EH', 'WAT', 'WU', 'WEB', 'WU1',
      //   'WU4', 'WTK', 'Q0', 'WTC', 'WZ1', 'WTA', 'F1', 'WTO', 'J21', 'KN',
      //   'KN', 'QB', 'WTH', 'WCC', 'DY', 'WN', 'F11', 'DD', 'WQ2', 'WO', 
      //   'WTS', 'WN1', 'C62', 'F81', 'DL', 'WUE', 'WK', 'WTX', 'WSA', 'WZA', 
      //   'WQ1', 'KI', 'DG', 'WTE', 'WTQ', 'WQ4', 'WCA', 'WQ', 'WUT', 'F8', 
      //   'WSO', 'WTP', 'DH', 'V5', 'WTB', 'P0', 'OR', 'WSC', 'C63', 'C6', 
      //   'F0', 'DK', 'WQ3', 'DE', 'WSE', 'WZB', 'WU2', 'T0', 'WTZ', 'WEA', 
      //   'WTT', 'DI', 'WTD', 'DC', 'F12', 'WO1', 'WTL', 'J22', 'C61', 'WCB', 
      //   'WUD', 'WTM', 'WU5', 'WJ', 'WJ1', 'WSF', 'WR', 'WSP', 'KM', 'WSB', 
      //   'J2'
      // ]

      if(level1List.includes(prod_id)){
        return 1
      } else {
        return 0
      }
    },
    doSendEmail(form) {
      let policyInfo = this.tab5_policyInfo
      policyInfo.add_method = this.tab5_add_method
      this.btn_send_loading = true
      Object.assign(form, policyInfo);
      sendValueAddedBonusIllustrationEmail(this.$store.state.userInfo.id, form, this.mailAttachmentName).then(
        result => {
          if (result.header && result.header.status === "200") {
            this.setToastMsg(result.header.message);
          } else {
            this.setToastMsg(result.header.message);
          }
          this.btn_send_loading = false
        });
    },
    download(){
      this.btn_download_loading = true
      // let newWindow;
      // if (!this.isBox) {
      //   newWindow = window.open("/crm/assets/common/ajax-loader.gif");
      // }
      this.tab5_policyInfo.add_method = this.tab5_add_method
      const dataJsonStr = JSON.stringify(this.tab5_policyInfo);
      downloadValueAddedBonusIllustration(this.$store.state.userInfo.id, dataJsonStr).then(
          result => {
            let arrayBuffer = new Uint8Array(result.file).buffer;          
            if (this.isBox) {
              this.boxSendBase64PdfData(arrayBuffer);
            } else {            
              let file = new Blob([arrayBuffer], { type: "application/pdf" });
              saveAs(file, this.mailAttachmentName)
              // if (window.navigator.msSaveOrOpenBlob) {
              //   window.navigator.msSaveOrOpenBlob(file, this.mailAttachmentName);
              // } else {
              //   newWindow.location = URL.createObjectURL(file);
              // }            
            }
            this.btn_download_loading = false
          }
      );
    },
    openPDF() {
      this.btn_open_loading = true
      this.tab5_policyInfo.add_method = this.tab5_add_method
      const dataJsonStr = JSON.stringify(this.tab5_policyInfo);
      downloadValueAddedBonusIllustration(this.$store.state.userInfo.id, dataJsonStr).then(
          result => {
            let arrayBuffer = new Uint8Array(result.file).buffer;   
            let file = new Blob([arrayBuffer], { type: "application/pdf" });
            let fileURL = window.URL.createObjectURL(file);
            window.open(fileURL);
            this.btn_open_loading = false
          }
      );
    },
    // 查詢繳清保額繳清始期資訊
    queryPaupInfo(){
      this.btn_paup_loading = true
      queryPaupInfo(
        this.$store.state.userInfo.id,
        this.tab5_policyNo
      ).then(result => {
        if (result.header && result.header.status == "200") {
          if(result.body.paupInfo){
            this.paupInfo = JSON.parse(result.body.paupInfo)
            const errMsg = this.paupInfo.ERR_MSG && this.paupInfo.ERR_MSG.trim()
            if(errMsg){
              this.paupResult = errMsg
            } else {
              this.paupResult = '繳清保額: ' + this.$options.filters.numberFormat(Number(this.paupInfo.PAUP_FACE_AMT)) + '元  繳清始期: ' + this.$options.filters.dateFormat(this.paupInfo.PAUP_BGN_DATE)
            }
          } else {
            this.$toast.info({title: '查無資料'})
          }
        }else{
          this.$toast.info({title: '查詢繳清保額與繳清始期資訊api發生錯誤'})
        }
        this.btn_paup_loading = false
      });
    },
    tab5_doSearch() {
      this.tab5_add_method = "";
      this.paupInfo = {};
      this.paupResult = "";
      if (!this.tab5_policyNo) {
        return false;
      }
      this.tab5_search_loading = true
      valueAdded_queryPolicyInfo(
        this.$store.state.userInfo.id,
        this.tab5_policyNo
      ).then(result => {
        if (result.header && result.header.status == "200") {
          if( result.body ){
            this.tab5_search_success = true
            if( result.body.FACE_AMT_UNIT !== '8'){
              this.tab5_policyInfo = result.body;
              this.tab5_level = this.getLevel(result.body.PROD_ID)
              if(this.tab5_level == 2){
                this.warningMessage = '本試算表僅供參考，尚需驗證數值'
                this.panelOpen("warningModalOpen");
              } else if(this.tab5_level == 0){
                this.$toast.info({title: '查無此保單號碼'})
                this.tab5_policyInfo = {}
                this.tab5_search_loading = false
                this.tab5_search_success = false
                return
              }
            } else {
              this.$toast.info({title: '保額單位為計劃別不適用此功能'})
              this.tab5_search_success = false
            }    

            if (result.body.EFT_CODE != '00' && result.body.EFT_CODE != '02') {
              this.$toast.info({title: '此件效力非試算範圍，僅支援契約效力00正常繳費、02終身險滿期。'})
              this.tab5_policyInfo = {}
              this.tab5_search_loading = false
              this.tab5_search_success = false
              return
            }
          } else {
            this.$toast.info({title: '非CRM有效之保單號碼'})
            this.tab5_search_success = false
          }
        } else {
          this.$toast.info({title: '查無此保單號碼'})
          this.tab5_search_success = false
          this.tab5_policyInfo = {}
        }
        this.tab5_search_loading = false
      });
    },
    doSearchPeer(pageNo) {
      if (!this.peer_startDate || !this.peer_endDate || !this.peer_inputType) {
        this.setToastMsg("建立日期起迄與 input type 為必填欄位");
        return;
      }
      
      let start = new Date(this.peer_startDate);
      let end = new Date(this.peer_endDate);
      let diffDays = Math.ceil(Math.abs(end - start) / (1000 * 60 * 60 * 24));
      if (diffDays > 31) {
        this.setToastMsg("建立日期起訖限制為1個月內");
        return;
      }
      this.peer_loading = true;
      this.peer_page = pageNo;
      this.peer_tableData = [];
      this.peer_total = 0;
      this.recog_contractId = "";
      this.recog_tableData = [];
      if (this.blobUrlMap) {
        Object.values(this.blobUrlMap).forEach(url => URL.revokeObjectURL(url));
        this.blobUrlMap = {};
      }
      
      let reqData = {
        query_type: "B001",
        query_agid: this.peer_agid.trim(), 
        start_date: this.fmDate(this.peer_startDate),
        end_date: this.fmDate(this.peer_endDate),
        input_type: this.peer_inputType,
        page: this.peer_page,
        pageSize: this.peer_pageSize,
        offset: (this.peer_page - 1) * this.peer_pageSize
      };

      queryPeerPolicyDataAPI(this.$store.state.userInfo.id, reqData).then(res => {
        this.peer_loading = false;
        
        if (res.header && res.header.status == "200") {
          let allData = res.body.datalist || res.body.dataList || [];
          this.peer_total = res.body.total || 0;
          this.peer_tableData = allData;
        } else {
          this.setToastMsg(res.header.message || "查詢失敗");
          this.peer_tableData = []; 
          this.peer_total = 0;
        }
      }).catch((err) => {
        console.error("同業保單查詢失敗:", err);
        this.peer_loading = false;
        this.peer_tableData = []; 
        this.peer_total = 0;
        this.setToastMsg("系統異常");
      });
    },
    openImagePreview(url) {
      console.log("準備打開圖片預覽，URL:", url);
      if (url) {
        this.previewImageUrl = url;
      } else {
        this.setToastMsg("圖片尚未載入，請稍後再試");
      }
    },
    closeImagePreview() {
      this.previewImageUrl = "";
    },
    peer_changePage(p) {
      if (p < 1 || p > this.peer_totalPages) return;
      this.doSearchPeer(p);
    },
    doSearchRecog() {
      if (!this.recog_contractId) {
        this.setToastMsg("Contract ID 為必填欄位");
        return;
      }
      this.recog_loading = true;
      this.recog_tableData = []; 
      let reqData = { query_type: "B020", contract_id: this.recog_contractId.trim() };
      queryPeerPolicyDataAPI(this.$store.state.userInfo.id, reqData).then(res => {
        this.recog_loading = false;
        
        if (res.header && res.header.status == "200") {
          this.recog_tableData = (res.body && (res.body.datalist || res.body.dataList)) || [];
          this.fetchImageBlobsForData(this.recog_tableData); 
        } else {
          this.setToastMsg(res.header.message || "查詢失敗");
          this.recog_tableData = []; 
        }
      }).catch((err) => {
        console.error("error：", err); 
        this.recog_loading = false;
        this.recog_tableData = []; 
        this.setToastMsg("系統異常");
      });
    },

    formatJson(val) {
      if (!val) return "";
      
      try {
        let jsonStr = val;
        if (typeof val === 'object' && val !== null) {
          if (val.value) {
            jsonStr = val.value; 
          } else {
            return JSON.stringify(val, null, 2);
          }
        }
        let jsonObj = JSON.parse(jsonStr);
        return JSON.stringify(jsonObj, null, 2);
        
      } catch (e) {
        return typeof val === 'object' ? JSON.stringify(val, null, 2) : val;
      }
    },
    base64ToBlobUrl(base64DataUri) {
      if (!base64DataUri) return '';
      try {
        const arr = base64DataUri.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        const blob = new Blob([u8arr], {type: mime});
        return URL.createObjectURL(blob); // 產生 Blob URL
      } catch (e) {
        console.error("Base64 轉 Blob 失敗", e);
        return '';
      }
    },
    async fetchImageBlobsForData(dataList) {
      if (!Array.isArray(dataList) || dataList.length === 0) return;

      for (const item of dataList) {
        console.log("檢查該筆資料是否有 image_name_list:", item); 
        this.$set(item, 'blob_urls', []); 
        console.log("後端傳送:" , item);
        if (item.image_name_list && item.image_name_list.length > 0) {
          for (let idx = 0; idx < item.image_name_list.length; idx++) {
            const fileName = item.image_name_list[idx];
            
            try {
              // 呼叫 API 取得單張圖片的 Blob 資料
              const res = await downloadImageBlobAPI(this.$store.state.userInfo.id, fileName);
              const blobData = res.data ? res.data : res;
              const blob = new Blob([blobData], { type: 'image/jpeg' });
              const url = URL.createObjectURL(blob);
              
              item.blob_urls.push(url);
              this.$set(this.blobUrlMap, `img_${item.contract_id}_${idx}`, url);
            } catch (error) {
              console.error(`圖片載入失敗 (contract_id: ${item.contract_id}, fileName: ${fileName})`, error);
              this.setToastMsg(`圖片 ${fileName} 載入失敗`);
            }
          }
        } else {
          console.warn(`Contract ID ${item.contract_id} 沒有圖片名稱清單`);
        }
      }
    },
    getBlobUrl(fileName) {
      return this.blobUrlMap[fileName] || ''; 
    },
    openImagePreview(url) {
      console.log("準備打開圖片預覽，URL:", url);
      if (url) {
        this.previewImageUrl = url;
      } else {
        this.setToastMsg("圖片正在載入中或無法取得，請稍後再試！");
      }
    },
    closeImagePreview() {
      this.previewImageUrl = "";
    },
    filterPeerAgid() {
      this.peer_agid = this.peer_agid.toUpperCase().replace(/[^A-Z0-9]/g, '');
    },
    onPeerRowClick(item) {
      // 只允許 contract_type = 1（主約）
      if (item.contract_type != 1) {
        return;
      }
      this.recog_contractId = item.contract_id;
    },
    resetTab6() {
      // 恢復同業保單查詢的初始狀態
      this.peer_agid = "";
      this.peer_inputType = "";
      this.peer_tableData = [];
      this.peer_total = 0;
      this.peer_page = 1;
      this.$nextTick(() => {
        this.peer_startDate = "";
        this.peer_endDate = "";
        
        if (this.$refs.peerPickerStart) {
          this.$refs.peerPickerStart.clearDate();
        }
        if (this.$refs.peerPickerEnd) {
          this.$refs.peerPickerEnd.clearDate();
        }
      });
      
      // 恢復辨識結果的初始狀態
      this.recog_contractId = "";
      this.recog_tableData = [];
      if (this.blobUrlMap) {
        Object.values(this.blobUrlMap).forEach(url => {
          URL.revokeObjectURL(url);
        });
        this.blobUrlMap = {};
      }
    },
  },
  filters: {
    ymdDateFormat(val) {
      if (!val) return "";
      return val.substring(0, 10);
    },
    mapContractType(val) {
      const map = { '1': '主約', '2': '附約' }; 
      return map[val] || val;
    },
    mapPayFreq(val) {
      const map = { '1': '月繳', '2': '季繳', '3': '半年繳', '4': '年繳', '05': '躉繳', '6': '彈性繳' };
      return map[val] || val;
    },
    mapPrd(val) {
      return val ? val + "年" : val;
    },
    mapInputType(val) {
      const map = { '2': '拍照上傳', '3': '(新)手動輸入' };
      return map[val] || val;
    }
  },
  mounted() {
    // 依照query切換頁籤
    if (this.$route.query["tab"]) {
      $(`a[href="#tab-${this.$route.query["tab"]}"]`).tab("show"); // Select tab by name
    }

    // 監聽 tabs 切換時觸發難字
    const vm = this;
    $('a[data-toggle="tab"]').on("shown.bs.tab", function(e) {
      vm.registerHanlink(); // for hard word
    });

    // 監聽 使用者按上一頁或下一頁之行為
    window.popstateMethod = function() {
      $(`a[href="#tab-${vm.$route.query["tab"]}"]`).tab("show"); // Select tab by name
    };
    window.addEventListener("popstate", window.popstateMethod);

    this.data_table_height = $(window).height() - 230 - 70;
    let self = this;
    $(window).bind("orientationchange", function(event) {
      self.data_table_height = parseInt($(window).height()) - 230 - 70;
    });

    this.tableWidth = document.querySelector("#query-datatable").offsetWidth;

    this.beginDate = this.begDate();

    this.tableHeight = parseInt($(window).height()) - 580;

    if (this.UserInfo.roles) {
      if (this.UserInfo.roles.hasOwnProperty('RLMX008')) {
        this.currentTab = 5;
      } else if (this.UserInfo.roles.hasOwnProperty('RLMX006')) {
        this.currentTab = 3;
      }
    }
  },
  beforeDestroy() {
    Object.values(this.blobUrlMap).forEach(url => {
      URL.revokeObjectURL(url);
    });
  },
};
</script>
<style lang="scss" scoped>
.dropdown-menu-left {
  left: -16px !important;
}
.filter-result-table thead tr,
.filter-result-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
.list.badgets .badget.gray.item {
  padding: 0 22px;
  color: #323a45;
  background: #e0e1e3;
  border-radius: 8px;
  margin-right: 10px;
  margin-top: 10px;
}

.table.datatable tbody tr > td:first-child {
  padding: 10px 10px;
}

.filter-result-table tbody {
  display: block;
  height: 400px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}

.empty-block-sm {
  text-align: center !important;
  background: #f5f5f5;
  text-align: center;
  font-size: 20px;
  padding: 0px 20px !important;
  margin: 0;
  height: 56px;

  h5 {
    margin-top: 0.5em;
  }
}

.w-85 {
  width: 85px !important;
}

table.table tr:last-child td.no-border {
  background-color: #fff !important; /* 或 transparent 都可，看整體風格 */
  box-shadow: none !important;
  border-top: 1px solid #f5f5f5;
}

.label-width {
  width: 100px;
}

/* 保持表格樣式一致，背景淺灰、全邊框 */
.table td {
  background-color: #f7f7f7;
  border: 1px solid #C2C4C7;
}

/* th 樣式保持不變 */
.table th {
  background: #00AA42;
  color: #FFF;
  border: 1px solid #C2C4C7;
  text-align: center;
}

/* 將 td label/input/select 區塊也變成一致樣式 */
.custom-th {
  background: #00AA42;
  color: #FFF;
  border: 1px solid #C2C4C7;
  padding: 0.72rem;
  text-align: center;
  width: calc(100% / 6);
  font-weight: bold;
}

.custom-td {
  width: calc(100% / 6);
  text-align: left;
  height: 44px !important;
}

.border-1 {
  border: 1px solid #C2C4C7 !important;
}

/* 去除最後一列空格的邊框 */
.table tr:last-child td.no-border {
  border: none !important;
  background-color: #fff !important;
  box-shadow: none !important;
}

/* 按鈕樣式微調：橢圓角 + 寬度加大 */
.custom-btn {
  padding: 0.7rem 2rem;
  border-radius: 30px;
  font-weight: bold;
}

.text-hint {
  font-weight: bold;
  color: #ed7d31;
}

.paup-result-title {
  flex-shrink: 0;
  white-space: nowrap;
}

.paup-result-message {
  min-width: 0;
  overflow-wrap: break-word;
}

.table-wrapper {
  position: relative;
}

.table-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: all;
}

.table-loading-text {
  font-size: 18px;
  color: #333;
}

.disabled {
  pointer-events: none;
  opacity: 0.9;
}

.section-loading {
  opacity: 0.6 !important;
}

.json-pre {
  white-space: pre-wrap; 
  word-break: break-all; 
  margin: 0; 
  font-family: inherit;
  font-size: 13px;
  background-color: transparent;
  border: none;
}

/* 圖片預覽彈窗 */
.peer-lightbox {
  position: fixed;
  top: 0; left: 0; width: 100vw; height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}
.peer-lightbox img {
  max-width: 90%;
  max-height: 90%;
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.3);
}
.peer-lightbox .peer-close-btn {
  position: absolute;
  top: 20px; right: 30px;
  font-size: 40px; color: white;
  cursor: pointer;
}
.cursor-pointer {
  cursor: pointer;
}
.nav-tabs {
  display: flex;
  justify-content: center; 
  flex-wrap: wrap !important;
  border-bottom: none; 
  width: 100%;
  margin-bottom: 0;
  padding-left: 0;
  list-style: none;
  position: relative;
}
.nav-tabs::after {
  display: none;
}
.nav-tabs::-webkit-scrollbar {
  display: none; 
}
.nav-tabs::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 4px;
}
.nav-tabs .nav-item {
  margin-bottom: 0; 
  position: relative;
  z-index: 2; 
}
.btn-orange {
  background-color: #ef8200;
  border-color: #ef8200;
  color: white !important;
  padding: 0.375rem 1.5rem; 
}
.btn-orange:hover {
  background-color: #d67400;
  border-color: #d67400;
}

.nav-tabs .nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  white-space: normal;
  word-break: break-all;
  width: 150px;
  height: 65px; 
  line-height: 1.3;
  padding: 8px;
  font-size: 1.1rem;
  font-weight: bold;
  color: #495057;
  background-color: #f8f9fa; 
  border: 1px solid #dee2e6;
  border-bottom: none; 
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  margin-right: 4px;
}
.nav-tabs .nav-link:hover {
  border-color: #e9ecef #e9ecef #dee2e6; 
}
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #00AA42 !important;
  background-color: #fff !important;
  border: 1px solid #dee2e6 !important;
  border-bottom: 2px solid #fff !important; 
  position: relative;
  margin-bottom: -2px; 
  z-index: 3;
}

.pagination {
  display: flex !important;
  list-style: none !important;
  padding: 0;
  margin: 0;
  align-items: center;
}
.pagination .page-item {
  margin: 0 2px;
}
.pagination .page-link {
  display: block;
  padding: 0.5rem 0.75rem;
  color: #00AA42; 
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  text-decoration: none;
}
.pagination .page-item.active .page-link {
  background-color: #00AA42;
  color: white;
  border-color: #00AA42;
}
.pagination .page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: #e9ecef;
}

.peer-lightbox {
  position: fixed;
  top: 0; left: 0; width: 100vw; height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}
.peer-lightbox img {
  max-width: 90%;
  max-height: 90%;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.4);
}
.peer-lightbox .peer-close-btn {
  position: absolute;
  top: 30px; right: 40px;
  font-size: 50px; color: white;
  cursor: pointer;
  z-index: 10001;
}

select.w-auto.form-control {
  min-width: 70px !important;            
  padding-right: 25px !important;     
  padding-left: 10px !important;       
}
</style>
